module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Tristec Racing","short_name":"Tristec","start_url":"/","background_color":"#ffffff","theme_color":"#00B7EB","display":"minimal-ui","icon":"src/images/tristec-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"cbdc885efc32a5e3b82d0676045e938a"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
